import { useQuery } from "@tanstack/react-query";
import Api from "../Api/Api.json";
import axios from "axios";

const fetchPatientByPhone = async (phone) => {
  if (!phone) return null;
  phone = phone.trim();
  if (phone.startsWith("0")) phone = phone.slice(1);

  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.TELEDOC_PROVIDER_API;
  const requestData = {
    task: "getPatientDetails",
    phone: phone,
  };
  const response = await axios.post(url, requestData, headers);
  if (!response.data) {
    throw new Error("Network response was not ok");
  }
  return response.data[0] || null; // Return the first patient found or null if none
};

export const usePatient = (phoneNumber, searchTriggered) => {
  return useQuery({
    queryKey: ["patientSearch", phoneNumber],
    queryFn: () => fetchPatientByPhone(phoneNumber),
    enabled: !!phoneNumber && phoneNumber.length > 0 && searchTriggered, // Only run the query if phoneNumber is provided
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
  });
};
